import React from 'react';
import { Snackbar, Alert, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '../../entrevista/components/EntrevistaViewer.css';
import { useCuestionarioSPViewer } from './hooks/useCuestionarioSPViewer';
import {
  CuestionarioSPHero,
  PatientProfileSection,
  IncontinenciaSection,
  CuestionarioViewerActions,
} from './viewer/CuestionarioSPViewerSections';

const CuestionarioIncontinenciaViewer = ({ idCuestionario, paciente }) => {
  const navigate = useNavigate();
  const {
    patientInfo,
    fields,
    puntuacionTotal,
    pFrecuencia,
    pCantidad,
    openGood,
    setOpenGood,
    handleExportPDF,
  } = useCuestionarioSPViewer({ idCuestionario, paciente });

  return (
    <Box className="entrevista-viewer" sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Box className="entrevista-viewer__shell" sx={{ maxWidth: 1080, width: '100%' }}>
        <Box id="pdf-content" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CuestionarioSPHero createdAt={patientInfo.createdAt} />
          <PatientProfileSection patientInfo={patientInfo} />
          <IncontinenciaSection
            fields={fields}
            puntuacionTotal={puntuacionTotal}
            pFrecuencia={pFrecuencia}
            pCantidad={pCantidad}
          />
        </Box>

        <CuestionarioViewerActions
          onExportPDF={handleExportPDF}
          onEdit={() => navigate(`/editar-sp/${paciente}/${idCuestionario}`)}
        />

        <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
          <Alert severity="success" onClose={() => setOpenGood(false)}>
            ¡Cuestionario actualizado!
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default CuestionarioIncontinenciaViewer;
